'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _semanticUiReact = require('semantic-ui-react');

var _targetLink = require('../target-link');

var _targetLink2 = _interopRequireDefault(_targetLink);

var _assets = require('../../utils/assets');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_IMAGE = 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/no_image_available.png';

var textTransform = {
  textTransform: 'none'
};

var sf = function sf(num) {
  var format = num > 1000 ? '0a' : '0';
  return (0, _numeral2.default)(num).format(format);
};

var SupportingDataModalBody = function SupportingDataModalBody(_ref) {
  var supportingData = _ref.supportingData,
      platform = _ref.platform,
      discussionName = _ref.discussionName,
      assetType = _ref.assetType,
      publishedDate = _ref.publishedDate,
      assetURL = _ref.assetURL,
      extraData = _ref.extraData;

  var filePath = (0, _assets.getSupportingDataField)(supportingData, 'filePath');
  var views = (0, _assets.getSupportingDataField)(supportingData, 'views');
  var likes = (0, _assets.getSupportingDataField)(supportingData, 'likes');
  var shares = (0, _assets.getSupportingDataField)(supportingData, 'shares');
  var comments = (0, _assets.getSupportingDataField)(supportingData, 'comments');
  var clicks = (0, _assets.getSupportingDataField)(supportingData, 'clicks');
  var isVK = platform === 'VK';
  var isBlog = platform === 'BLOG';
  var isSnapchat = platform === 'SNAPCHAT';
  return _react2.default.createElement(
    _semanticUiReact.Grid,
    { columns: 2 },
    _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 5, verticalAlign: 'top' },
        _react2.default.createElement(_semanticUiReact.Image, { src: (0, _assets.getS3Url)(filePath, DEFAULT_IMAGE), size: 'large' })
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 11 },
        _react2.default.createElement(
          _semanticUiReact.Card,
          { fluid: true },
          _react2.default.createElement(
            _semanticUiReact.Card.Content,
            null,
            isVK && _react2.default.createElement(
              _semanticUiReact.Statistic.Group,
              { widths: 'three' },
              _react2.default.createElement(
                _semanticUiReact.Statistic,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Value,
                  { style: textTransform },
                  sf(views)
                ),
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Label,
                  null,
                  'views'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Statistic,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Value,
                  { style: textTransform },
                  sf(likes)
                ),
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Label,
                  null,
                  'likes'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Statistic,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Value,
                  { style: textTransform },
                  sf(comments)
                ),
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Label,
                  null,
                  'comments'
                )
              )
            ),
            isBlog && _react2.default.createElement(
              _semanticUiReact.Statistic.Group,
              { widths: 'three' },
              _react2.default.createElement(
                _semanticUiReact.Statistic,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Value,
                  { style: textTransform },
                  sf(views)
                ),
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Label,
                  null,
                  'views'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Statistic,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Value,
                  { style: textTransform },
                  sf(clicks)
                ),
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Label,
                  null,
                  'clicks'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Statistic,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Value,
                  { style: textTransform },
                  sf(comments)
                ),
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Label,
                  null,
                  'comments'
                )
              )
            ),
            isSnapchat && _react2.default.createElement(
              _semanticUiReact.Statistic.Group,
              { widths: 'two' },
              _react2.default.createElement(
                _semanticUiReact.Statistic,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Value,
                  { style: textTransform },
                  sf(views)
                ),
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Label,
                  null,
                  'views'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Statistic,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Value,
                  { style: textTransform },
                  sf(shares)
                ),
                _react2.default.createElement(
                  _semanticUiReact.Statistic.Label,
                  null,
                  'shares'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Card,
          { fluid: true },
          _react2.default.createElement(
            _semanticUiReact.Card.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table,
              { basic: 'very', celled: true, fluid: true },
              _react2.default.createElement(
                _semanticUiReact.Table.Body,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    { width: 4 },
                    _react2.default.createElement(
                      _semanticUiReact.Header,
                      { as: 'h4' },
                      _react2.default.createElement(
                        _semanticUiReact.Header.Content,
                        null,
                        'PLATFORM / TYPE'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    { width: 12 },
                    platform,
                    ' / ',
                    assetType
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Header,
                      { as: 'h4' },
                      _react2.default.createElement(
                        _semanticUiReact.Header.Content,
                        null,
                        'INFLUENCER'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    discussionName || '-'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Header,
                      { as: 'h4' },
                      _react2.default.createElement(
                        _semanticUiReact.Header.Content,
                        null,
                        'POSTED'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    publishedDate ? (0, _moment2.default)(publishedDate).format('YYYY-MM-DD') : '-'
                  )
                ),
                !isSnapchat && _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Header,
                      { as: 'h4' },
                      _react2.default.createElement(
                        _semanticUiReact.Header.Content,
                        null,
                        'LINK'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    _react2.default.createElement(
                      _targetLink2.default,
                      {
                        renderIf: true,
                        href: assetURL
                      },
                      _lodash2.default.truncate(assetURL, { length: 80 })
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Header,
                      { as: 'h4' },
                      _react2.default.createElement(
                        _semanticUiReact.Header.Content,
                        null,
                        'CAPTION'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    _lodash2.default.get(extraData, 'text', 'no caption created')
                  )
                )
              )
            )
          )
        )
      )
    )
  );
};

SupportingDataModalBody.propTypes = {
  supportingData: _propTypes2.default.array,
  platform: _propTypes2.default.string,
  discussionName: _propTypes2.default.string,
  assetType: _propTypes2.default.string,
  assetURL: _propTypes2.default.string,
  publishedDate: _propTypes2.default.string,
  extraData: _propTypes2.default.object
};

SupportingDataModalBody.defaultProps = {
  supportingData: [],
  platform: '-',
  discussionName: '-',
  assetType: '-',
  publishedDate: '-',
  assetURL: '-',
  extraData: { text: '-' }
};

exports.default = SupportingDataModalBody;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/supporing-data-modal/body.js
 ** module id = 2604
 ** module chunks = 0
 **/